// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__CwGrH","inputWrap":"Table_inputWrap__35mzO","col":"Table_col__1SuPC","bmiTooltip":"Table_bmiTooltip__1gVay"};